import { render, staticRenderFns } from "./DetailInfoGroup.vue?vue&type=template&id=1861009e&scoped=true"
import script from "./DetailInfoGroup.vue?vue&type=script&lang=js"
export * from "./DetailInfoGroup.vue?vue&type=script&lang=js"
import style0 from "./DetailInfoGroup.vue?vue&type=style&index=0&id=1861009e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1861009e",
  null
  
)

export default component.exports